import { AxiosResponse } from 'axios';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { createScopedErrorHandler } from 'utils/functions/handleError';
import {
  apiRequestFailed,
  apiRequestSuccess,
  markRequestAsPending,
  requestDataIfNecessary,
} from './api.actions';
import { selectApiState } from './api.selectors';
import {
  baseFetcher,
  BaseFetcherResult,
  BaseFetcherReturn,
} from './apiStatelessJwt.saga';

const handleApiSagaError = createScopedErrorHandler('saga');

function* handleApiRequest(action: ReturnType<typeof requestDataIfNecessary>) {
  const response: BaseFetcherReturn = yield call(baseFetcher, action.payload);

  if (response.result === BaseFetcherResult.SUCCESS) {
    yield put(
      apiRequestSuccess({
        ...response.payload,
        response: response.response as AxiosResponse<any>,
      }),
    );
  } else if (response.result === BaseFetcherResult.API_REQUEST_FAILED) {
    yield put(
      apiRequestFailed({ ...response.payload, error: response.error as any }),
    );
  }
}

function* triggerRequestIfNecessary(
  action: ReturnType<typeof requestDataIfNecessary>,
) {
  try {
    const {
      payload: { resourceId },
    } = action;
    const { loaded, pending } = yield select(selectApiState);

    const isResourcePresent = !!loaded?.[resourceId];
    const isResourceInvalidated = loaded?.[resourceId]?.didInvalidate ?? false;

    if (isResourcePresent && !isResourceInvalidated) {
      return;
    }

    const isResourceNotPending = !pending[resourceId];

    if (isResourceNotPending) {
      yield put(markRequestAsPending(action.payload));
    }
  } catch (sagaError) {
    handleApiSagaError(sagaError);
  }
}

export default function* rootApiSaga() {
  yield all([
    takeEvery(requestDataIfNecessary.type, triggerRequestIfNecessary),
    takeEvery(markRequestAsPending.type, handleApiRequest),
  ]);
}
